export enum ItemActionType {
	Edit = "edit",
	Delete = "delete",
}

export enum LimitedItemStepStatusId {
	Completed = 1,
	Ready = 2,
	Pending = 3,
	Recalled = 4,
	ChangeRequested = 5,
	Rejected = 6,
	Deleted = 7,
	Delegated = 8,
	Escalated = 9,
	Cancelled = 10,
}
